import { ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';
import { useMe } from './MeContext';

export function AuthGuard({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const { state } = useMe();

  if (auth.isLoading) return <div className="container py-5">Caricamento sessione…</div>;
  if (auth.error) return <div className="container py-5">Errore di autenticazione: {auth.error.message}</div>;
  if (!auth.isAuthenticated) {
    void auth.signinRedirect();
    return <div className="container py-5">Reindirizzamento a Keycloak…</div>;
  }

  if (state.kind === 'loading') return <div className="container py-5">Caricamento profilo…</div>;
  if (state.kind === 'no-membership') return <Navigate to="/not-authorized" replace />;
  return <>{children}</>;
}
